import { render, staticRenderFns } from "./DHZ.vue?vue&type=template&id=456b39ca"
import script from "./DHZ.vue?vue&type=script&lang=js"
export * from "./DHZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports